import Vue from 'vue'
// 导出空白vue对象
export default new Vue()